<template>
  <div id="app">
    <Loader/>
    <router-view/>
  </div>
</template>

<script>
import Loader from "@/components/layout/Loader.vue";
export default {
  components: { Loader },
  computed: {
    loading() {
      return this.$store.getters.getLoadingState;
    }
  },
  data() {
    return {
      name: this.$route.name
    }
  }
}
</script>

<style lang="scss">
@import 'assets/css/style';
</style>
